<template>
  <div>
    <v-row cols="12">
      <v-col md="4" v-for="(invite, i) in $store.state.invites" :key="invite.id">
        <v-card>
          <v-card-title>
            Atender as lojas
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>            
            <v-progress-circular
              v-if="invite.loading"
              :size="70"
              :width="3"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-list-group
              v-for="(store) in invite.stores"
              :key="store.id"
              v-model="store.active"
              no-action
              v-else
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="store.name"></v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list flat>
                <v-list-item
                  v-for="(status, i) in store.pivot.contact_statuses"
                  :key="`${store.name}-${status.status}`"
                >
                  {{status.status}}
                </v-list-item>
              </v-list>
            </v-list-group>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-actions class="text-center">
            <v-btn
              color="primary"
              block
              @click="accept(invite, i)"
            >
              Aceitar convite
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

  name: 'Invites',
  created() {
    this.$store.dispatch('fetchInvites');    
  },
  methods: {
    accept(invite, i) {      
      this.$store.dispatch('acceptInvite', Object.assign(invite, {answer: 'accept'}));  
      setTimeout(() => this.$emit('updateContent'), 1000);    
    }
  },
  data () {
    return {
      active:true,
    }
  }
}
</script>

<style lang="css" scoped>
</style>